import React from "react";
import { Layout, Button, Avatar } from "antd";
import { MenuOutlined } from "@ant-design/icons";

const { Header: AntHeader } = Layout;

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <AntHeader
      className="header"
      style={{
        backgroundColor: "#FFF",
        borderBottom: "1px solid #CCC",
        padding: "16px 80px",
        paddingLeft: "320px", // Account for sidebar width + padding
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "auto",
        minHeight: "80px",
        position: "relative",
        zIndex: 50,
      }}
    >
      {/* Mobile Menu Button */}
      <Button
        type="text"
        icon={<MenuOutlined />}
        onClick={onMenuClick}
        className="mobile-menu-button"
        style={{
          fontSize: "18px",
          width: "40px",
          height: "40px",
        }}
      />

      {/* Avatar */}
      <Avatar
        size={48}
        style={{
          backgroundColor: "#4979A7",
          color: "#FFF",
          fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
          fontSize: "20px",
          fontWeight: "700",
          letterSpacing: "0.5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "auto",
        }}
      >
        E
      </Avatar>
    </AntHeader>
  );
};

export default Header;
